import * as React from 'react';
import './ContentToPrint.scss';
import { IReturnDetail, IStatusItem } from 'src/services/returns/typings';
import localeFormatingInstance from 'src/translation/localeFormating';
import i18n from 'src/translation/i18n';
import { Public } from '@material-ui/icons';

interface IContentToPrintProps {
  statusData: IStatusItem;
  total: number;
}
class ContentToPrint extends React.Component<IContentToPrintProps, any> {

  public getShippingTypeStatus(rawTxt: string) {
    switch (rawTxt?.toLowerCase()) {
      case 'drop_off_store':
        return i18n.t('myReturns.dropOffStoreText');
      case 'self_shipping':
        return i18n.t('myReturns.selfShippingText');
      case 'prepaid_shipping':
        return i18n.t('myReturns.prepaidShippingText');
      default:
        return rawTxt;
    }
  }
  public render() {
    return (
      <div className="rp-content-to-print">
        <div className="container-fluid">
          <div className="row rp-content-to-print-wrapper">
            <div className="col-2">
              <p className="rp-content-to-print-header">
                {i18n.t('myReturns.returnNo')}
              </p>
            </div>
            <div className="col-2">
              <p className="rp-content-to-print-header">
                {i18n.t('myReturns.pONumber')}
              </p>
            </div>
            <div className="col-2">
              <p className="rp-content-to-print-header">
                {i18n.t('myOrders.status')}
              </p>
            </div>
            <div className="col-2">
              <p className="rp-content-to-print-header">
                {i18n.t('myReturns.SubmittedOn')}
              </p>
            </div>
            <div className="col-2">
              <p className="rp-content-to-print-header">
                {i18n.t('myReturns.creditedOn')}
              </p>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row rp-content-to-print-row">
            <div className="col-2">
              <p className="rp-content-to-print-row-content">
                {this.props.statusData.rmaNumber}
              </p>
            </div>
            <div className="col-2">
              <p className="rp-content-to-print-row-content">
                {this.props.statusData.poNumber}
              </p>
            </div>
            <div className="col-2">
              <p className="rp-content-to-print-row-content">
                {this.props.statusData.status}
              </p>
            </div>
            <div className="col-2">
              <p className="rp-content-to-print-row-content">
                {this.props.statusData.submissionDate &&
                  localeFormatingInstance.formatDate(
                    this.props.statusData.submissionDate,
                    'short'
                  )}
              </p>
            </div>
            <div className="col-2">
              <p className="rp-content-to-print-row-content">
                {this.props.statusData.creditedDate &&
                  localeFormatingInstance.formatDate(
                    this.props.statusData.creditedDate,
                    'short'
                  )}
              </p>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row rp-content-to-print-wrapper">
            <div className="col-2 partNumber">
              <p className="rp-content-to-print-header">
                {i18n.t('myReturns.partNo')}
              </p>
            </div>
            <div className="col-1 invoiceNumber">
              <p className="rp-content-to-print-header">
                {i18n.t('myReturns.invoiceNo')}
              </p>
            </div>
            <div className="col-1 invoiceDate">
              <p className="rp-content-to-print-header">
                {i18n.t('myReturns.invoiceDate')}
              </p>
            </div>
            <div className="col-1 price">
              <p className="rp-content-to-print-header">
                {i18n.t('myReturns.price')}
              </p>
            </div>
            <div className="col-1 d-flex justify-content-center returnQty">
              <p className="rp-content-to-print-header text-center">
                {i18n.t('myReturns.returnQty')}
              </p>
            </div>
            <div className="col-1 d-flex justify-content-center restockingFee">
              <p className="rp-content-to-print-header text-center">
                {i18n.t('myReturns.restockingFee')}
              </p>
            </div>
            <div className="col-2 d-flex justify-content-center creditAmount">
              <p className="rp-content-to-print-header text-center">
                {i18n.t('myReturns.creditAmount')}
              </p>
            </div>
            <div className="col-3 reason">
              <p className="rp-content-to-print-header text-center">
                {i18n.t('myReturns.reasonTxt')}
              </p>
              <p className="rp-content-to-print-header text-center reference">
                / {i18n.t('myReturns.ReferenceTxt')}
              </p>
            </div>
          </div>
        </div>
        {this.props.statusData.returnDetails.map(part => (
          <div className="rp-content-to-print-row">
            <div className="container-fluid">
              <div className="row">
                <div className="col-2 d-flex align-items-center partNumber">
                  <p className="rp-content-to-print-row-content">
                    {part.partNumber}
                  </p>
                </div>
                <div className="col-1 d-flex align-items-center invoiceNumber">
                  <p className="rp-content-to-print-row-content">
                    {part.invoiceNumber}
                  </p>
                </div>
                <div className="col-1 d-flex align-items-center invoiceDate">
                  <p className="rp-content-to-print-row-content">
                    {localeFormatingInstance.formatDate(
                      part.invoiceDate,
                      'short'
                    )}
                  </p>
                </div>
                <div className="col-1 d-flex flex-column align-items-center price">
                  <p className="rp-content-to-print-row-content quantity">
                    {localeFormatingInstance.formatCurrency(part.price)}
                    {part.hasCoreIncluded && '*'}
                  </p>
                  {part.hasCoreIncluded && (
                    <p className="rp-content-to-print-row-content message">
                      Includes a Core Charge
                    </p>
                  )}
                </div>
                <div className="col-1 d-flex justify-content-center align-items-center returnQty">
                  <p className="rp-content-to-print-row-content text-center">
                    {part.returnQuantity}
                  </p>
                </div>
                <div className="col-1 d-flex justify-content-center align-items-center restockingFee">
                  <p className="rp-content-to-print-row-content text-center">
                    {part.restockingFee}%
                  </p>
                </div>
                <div className="col-2 d-flex justify-content-center align-items-center creditAmount">
                  <p className="rp-content-to-print-row-content quantity text-center">
                    {localeFormatingInstance.formatCurrency(part.returnAmount)}
                  </p>
                </div>
                <div className="col-3 d-flex align-items-center reason">
                  <p className="rp-content-to-print-row-content text-center">
                    {part.reason}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
        {this.props.statusData && this.props.statusData.shipmentType!==null &&
        <p className="rp-content-to-print-total">
          {i18n.t('myReturns.shippingType')}: {this.getShippingTypeStatus(this.props.statusData.shipmentType)}
        </p>
        }

      {this.props.statusData && this.props.statusData.shippingCharges>0 &&
      <p className="rp-content-to-print-total">
          {`${i18n.t(
            'myReturns.shippingCharges'
          )}: ${localeFormatingInstance.formatCurrency(this.props.statusData.shippingCharges)}`}
        </p>
      }
        <p className="rp-content-to-print-total">
          {`${i18n.t(
            'myReturns.totalEstimatedCredit'
          )}: ${localeFormatingInstance.formatCurrency(this.props.statusData.returnTotal)}`}
        </p>
       
      </div>
    );
  }
}

export default ContentToPrint;
